export default "__VITE_ASSET__Cf76JyQO__"